import { useTenants } from '@api/tenants';
import { Typography } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid';
import React from 'react';

const AuditTenantsCell: React.FC<GridRenderCellParams<string[]>> = ({
	value
}) => {
	const { data } = useTenants();
	const withTenantsNames = value?.map((tenantId) => {
		const tenantName = data?.tenants?.find((t) => t.id === tenantId)?.name;
		if (tenantName) {
			return `${tenantId} (${tenantName})`;
		}
		return tenantId;
	});

	const display = withTenantsNames?.join(', ');
	return (
		<Typography variant="body2" noWrap>
			{display}
		</Typography>
	);
};

export default AuditTenantsCell;
